export default __webpack_public_path__ + "static/media/manualEntry.f5756a93.png";